import { MessageCircle, Phone } from "lucide-react";
import { BUSINESS } from "@/lib/config";

export default function FloatingActions() {
  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3">
      <a
        data-testid="whatsapp-float"
        href={`https://wa.me/${BUSINESS.whatsapp}?text=${encodeURIComponent(
          "Hi Sutra Interio, I'd like to know more about your interior design services."
        )}`}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
        className="w-13 h-13 grid place-items-center bg-[#25D366] text-white rounded-full soft-shadow p-4 hover:scale-105 transition-transform duration-300"
      >
        <MessageCircle size={22} />
      </a>
      <a
        data-testid="call-float"
        href={`tel:${BUSINESS.phoneRaw}`}
        aria-label="Call us"
        className="w-13 h-13 grid place-items-center bg-olive text-beige rounded-full soft-shadow p-4 hover:bg-[#21463c] hover:scale-105 transition-all duration-300"
      >
        <Phone size={22} />
      </a>
    </div>
  );
}
